// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file questionnaire/v2/model.proto (package questionnaire.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { DocumentError } from "../../artifacts/v1/model_pb";
import { file_artifacts_v1_model } from "../../artifacts/v1/model_pb";
import type { AnalysisResult } from "../../controls/v1/analysis_result_pb";
import { file_controls_v1_analysis_result } from "../../controls/v1/analysis_result_pb";
import type { ControlStatus } from "../../controls/v1/control_status_pb";
import { file_controls_v1_control_status } from "../../controls/v1/control_status_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { RiskQuestionnaireQuestionThreadActivity } from "../../inventory/v1/control_service_pb";
import { file_inventory_v1_control_service } from "../../inventory/v1/control_service_pb";
import type { QuestionnaireStatus } from "../common/v1/questionnaire_status_pb";
import { file_questionnaire_common_v1_questionnaire_status } from "../common/v1/questionnaire_status_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file questionnaire/v2/model.proto.
 */
export const file_questionnaire_v2_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_artifacts_v1_model, file_controls_v1_analysis_result, file_controls_v1_control_status, file_google_protobuf_timestamp, file_inventory_v1_control_service, file_questionnaire_common_v1_questionnaire_status]);

/**
 * @generated from message questionnaire.v2.BaseQuestionnaire
 */
export type BaseQuestionnaire = Message<"questionnaire.v2.BaseQuestionnaire"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: questionnaire.common.v1.QuestionnaireStatus status = 6;
   */
  status: QuestionnaireStatus;

  /**
   * @generated from field: questionnaire.v2.QuestionnaireType type = 7;
   */
  type: QuestionnaireType;

  /**
   * @generated from field: optional google.protobuf.Timestamp finished_at = 8;
   */
  finishedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp due_date = 9;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: optional string project_name = 10;
   */
  projectName?: string;

  /**
   * @generated from field: optional string project_id = 11;
   */
  projectId?: string;

  /**
   * @generated from field: optional string assessment_id = 12;
   */
  assessmentId?: string;

  /**
   * @generated from field: string company_id = 13;
   */
  companyId: string;

  /**
   * @generated from field: google.protobuf.Timestamp status_updated_at = 14;
   */
  statusUpdatedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_recipient_activity_at = 15;
   */
  lastRecipientActivityAt?: Timestamp;

  /**
   * @generated from field: optional string outreach_campaign_id = 16;
   */
  outreachCampaignId?: string;

  /**
   * @generated from field: optional string outreach_campaign_name = 17;
   */
  outreachCampaignName?: string;
};

/**
 * Describes the message questionnaire.v2.BaseQuestionnaire.
 * Use `create(BaseQuestionnaireSchema)` to create a new message.
 */
export const BaseQuestionnaireSchema: GenMessage<BaseQuestionnaire> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 0);

/**
 * @generated from message questionnaire.v2.QuestionnaireRecipient
 */
export type QuestionnaireRecipient = Message<"questionnaire.v2.QuestionnaireRecipient"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string link = 3;
   */
  link: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_notifications_read = 4;
   */
  lastNotificationsRead?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_access = 5;
   */
  lastAccess?: Timestamp;
};

/**
 * Describes the message questionnaire.v2.QuestionnaireRecipient.
 * Use `create(QuestionnaireRecipientSchema)` to create a new message.
 */
export const QuestionnaireRecipientSchema: GenMessage<QuestionnaireRecipient> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 1);

/**
 * @generated from message questionnaire.v2.Questionnaire
 */
export type Questionnaire = Message<"questionnaire.v2.Questionnaire"> & {
  /**
   * @generated from field: questionnaire.v2.BaseQuestionnaire base = 1;
   */
  base?: BaseQuestionnaire;

  /**
   * @generated from oneof questionnaire.v2.Questionnaire.questionnaire
   */
  questionnaire: {
    /**
     * @generated from field: questionnaire.v2.ManualQuestionnaire manual_questionnaire = 2;
     */
    value: ManualQuestionnaire;
    case: "manualQuestionnaire";
  } | {
    /**
     * @generated from field: questionnaire.v2.RiskQuestionnaire risk_questionnaire = 3;
     */
    value: RiskQuestionnaire;
    case: "riskQuestionnaire";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message questionnaire.v2.Questionnaire.
 * Use `create(QuestionnaireSchema)` to create a new message.
 */
export const QuestionnaireSchema: GenMessage<Questionnaire> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 2);

/**
 * @generated from message questionnaire.v2.ManualQuestionnaire
 */
export type ManualQuestionnaire = Message<"questionnaire.v2.ManualQuestionnaire"> & {
  /**
   * @generated from field: int32 total_flagged_answers = 1;
   */
  totalFlaggedAnswers: number;

  /**
   * @generated from field: int32 total_awaiting_comments = 2;
   */
  totalAwaitingComments: number;

  /**
   * @generated from field: optional questionnaire.v2.ManualQuestionnaireQuestions questions = 3;
   */
  questions?: ManualQuestionnaireQuestions;

  /**
   * @generated from field: int32 total_questions = 4;
   */
  totalQuestions: number;

  /**
   * @generated from field: int32 total_answered = 5;
   */
  totalAnswered: number;
};

/**
 * Describes the message questionnaire.v2.ManualQuestionnaire.
 * Use `create(ManualQuestionnaireSchema)` to create a new message.
 */
export const ManualQuestionnaireSchema: GenMessage<ManualQuestionnaire> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 3);

/**
 * @generated from message questionnaire.v2.ManualQuestionnaireQuestions
 */
export type ManualQuestionnaireQuestions = Message<"questionnaire.v2.ManualQuestionnaireQuestions"> & {
  /**
   * @generated from field: repeated questionnaire.v2.ManualQuestion questions = 1;
   */
  questions: ManualQuestion[];
};

/**
 * Describes the message questionnaire.v2.ManualQuestionnaireQuestions.
 * Use `create(ManualQuestionnaireQuestionsSchema)` to create a new message.
 */
export const ManualQuestionnaireQuestionsSchema: GenMessage<ManualQuestionnaireQuestions> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 4);

/**
 * @generated from message questionnaire.v2.ManualQuestionnaireTemplate
 */
export type ManualQuestionnaireTemplate = Message<"questionnaire.v2.ManualQuestionnaireTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: int32 question_count = 6;
   */
  questionCount: number;
};

/**
 * Describes the message questionnaire.v2.ManualQuestionnaireTemplate.
 * Use `create(ManualQuestionnaireTemplateSchema)` to create a new message.
 */
export const ManualQuestionnaireTemplateSchema: GenMessage<ManualQuestionnaireTemplate> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 5);

/**
 * @generated from message questionnaire.v2.ManualQuestionnaireQuestionOptions
 */
export type ManualQuestionnaireQuestionOptions = Message<"questionnaire.v2.ManualQuestionnaireQuestionOptions"> & {
  /**
   * @generated from field: repeated questionnaire.v2.ManualQuestionnaireQuestionOption options = 1;
   */
  options: ManualQuestionnaireQuestionOption[];
};

/**
 * Describes the message questionnaire.v2.ManualQuestionnaireQuestionOptions.
 * Use `create(ManualQuestionnaireQuestionOptionsSchema)` to create a new message.
 */
export const ManualQuestionnaireQuestionOptionsSchema: GenMessage<ManualQuestionnaireQuestionOptions> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 6);

/**
 * @generated from message questionnaire.v2.ManualQuestionnaireQuestionOption
 */
export type ManualQuestionnaireQuestionOption = Message<"questionnaire.v2.ManualQuestionnaireQuestionOption"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: optional string label = 2;
   */
  label?: string;
};

/**
 * Describes the message questionnaire.v2.ManualQuestionnaireQuestionOption.
 * Use `create(ManualQuestionnaireQuestionOptionSchema)` to create a new message.
 */
export const ManualQuestionnaireQuestionOptionSchema: GenMessage<ManualQuestionnaireQuestionOption> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 7);

/**
 * @generated from message questionnaire.v2.ManualQuestionnaireTemplateQuestion
 */
export type ManualQuestionnaireTemplateQuestion = Message<"questionnaire.v2.ManualQuestionnaireTemplateQuestion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: questionnaire.v2.ManualQuestionKind kind = 6;
   */
  kind: ManualQuestionKind;

  /**
   * @generated from field: optional questionnaire.v2.ManualQuestionnaireQuestionOptions options = 7;
   */
  options?: ManualQuestionnaireQuestionOptions;

  /**
   * @generated from field: int32 priority = 8;
   */
  priority: number;

  /**
   * @generated from field: bool is_required = 9;
   */
  isRequired: boolean;
};

/**
 * Describes the message questionnaire.v2.ManualQuestionnaireTemplateQuestion.
 * Use `create(ManualQuestionnaireTemplateQuestionSchema)` to create a new message.
 */
export const ManualQuestionnaireTemplateQuestionSchema: GenMessage<ManualQuestionnaireTemplateQuestion> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 8);

/**
 * @generated from message questionnaire.v2.ManualQuestionRadioAnswer
 */
export type ManualQuestionRadioAnswer = Message<"questionnaire.v2.ManualQuestionRadioAnswer"> & {
  /**
   * @generated from field: string option_id = 1;
   */
  optionId: string;
};

/**
 * Describes the message questionnaire.v2.ManualQuestionRadioAnswer.
 * Use `create(ManualQuestionRadioAnswerSchema)` to create a new message.
 */
export const ManualQuestionRadioAnswerSchema: GenMessage<ManualQuestionRadioAnswer> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 9);

/**
 * @generated from message questionnaire.v2.ManualQuestionCheckboxAnswer
 */
export type ManualQuestionCheckboxAnswer = Message<"questionnaire.v2.ManualQuestionCheckboxAnswer"> & {
  /**
   * @generated from field: repeated string options = 1;
   */
  options: string[];
};

/**
 * Describes the message questionnaire.v2.ManualQuestionCheckboxAnswer.
 * Use `create(ManualQuestionCheckboxAnswerSchema)` to create a new message.
 */
export const ManualQuestionCheckboxAnswerSchema: GenMessage<ManualQuestionCheckboxAnswer> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 10);

/**
 * @generated from message questionnaire.v2.ManualQuestionnaireFileAnswer
 */
export type ManualQuestionnaireFileAnswer = Message<"questionnaire.v2.ManualQuestionnaireFileAnswer"> & {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: optional bool file_cannot_be_provided = 3;
   */
  fileCannotBeProvided?: boolean;
};

/**
 * Describes the message questionnaire.v2.ManualQuestionnaireFileAnswer.
 * Use `create(ManualQuestionnaireFileAnswerSchema)` to create a new message.
 */
export const ManualQuestionnaireFileAnswerSchema: GenMessage<ManualQuestionnaireFileAnswer> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 11);

/**
 * @generated from message questionnaire.v2.ManualQuestionnaireQuestionAnswer
 */
export type ManualQuestionnaireQuestionAnswer = Message<"questionnaire.v2.ManualQuestionnaireQuestionAnswer"> & {
  /**
   * @generated from oneof questionnaire.v2.ManualQuestionnaireQuestionAnswer.answer
   */
  answer: {
    /**
     * @generated from field: string text = 1;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: questionnaire.v2.ManualQuestionnaireFileAnswer file = 2;
     */
    value: ManualQuestionnaireFileAnswer;
    case: "file";
  } | {
    /**
     * @generated from field: google.protobuf.Timestamp date = 3;
     */
    value: Timestamp;
    case: "date";
  } | {
    /**
     * @generated from field: questionnaire.v2.ManualQuestionRadioAnswer radio_option = 4;
     */
    value: ManualQuestionRadioAnswer;
    case: "radioOption";
  } | {
    /**
     * @generated from field: questionnaire.v2.ManualQuestionCheckboxAnswer selected_options = 5;
     */
    value: ManualQuestionCheckboxAnswer;
    case: "selectedOptions";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message questionnaire.v2.ManualQuestionnaireQuestionAnswer.
 * Use `create(ManualQuestionnaireQuestionAnswerSchema)` to create a new message.
 */
export const ManualQuestionnaireQuestionAnswerSchema: GenMessage<ManualQuestionnaireQuestionAnswer> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 12);

/**
 * @generated from message questionnaire.v2.ManualQuestionThreadActivity
 */
export type ManualQuestionThreadActivity = Message<"questionnaire.v2.ManualQuestionThreadActivity"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from oneof questionnaire.v2.ManualQuestionThreadActivity.user_id
   */
  userId: {
    /**
     * @generated from field: string assessor_user_id = 2;
     */
    value: string;
    case: "assessorUserId";
  } | {
    /**
     * @generated from field: string recipient_id = 3;
     */
    value: string;
    case: "recipientId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string user_name = 4;
   */
  userName: string;

  /**
   * @generated from field: string comment = 5;
   */
  comment: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * Set when the comment's live copy is a Liveblocks thread; clients render the thread instead of the stored text.
   *
   * @generated from field: optional string liveblocks_thread_id = 7;
   */
  liveblocksThreadId?: string;
};

/**
 * Describes the message questionnaire.v2.ManualQuestionThreadActivity.
 * Use `create(ManualQuestionThreadActivitySchema)` to create a new message.
 */
export const ManualQuestionThreadActivitySchema: GenMessage<ManualQuestionThreadActivity> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 13);

/**
 * @generated from message questionnaire.v2.RiskQuestionnaire
 */
export type RiskQuestionnaire = Message<"questionnaire.v2.RiskQuestionnaire"> & {
  /**
   * @generated from field: int32 total_gaps = 1;
   */
  totalGaps: number;

  /**
   * @generated from field: int32 total_no_evidence = 2;
   */
  totalNoEvidence: number;

  /**
   * @generated from field: int32 total_validated = 3;
   */
  totalValidated: number;

  /**
   * @generated from field: optional questionnaire.v2.RiskQuestionnaireQuestions questions = 4;
   */
  questions?: RiskQuestionnaireQuestions;

  /**
   * @generated from field: int32 total_awaiting_recipient = 5;
   */
  totalAwaitingRecipient: number;

  /**
   * @generated from field: int32 total_not_applicable = 6;
   */
  totalNotApplicable: number;

  /**
   * @generated from field: int32 total_attested = 7;
   */
  totalAttested: number;
};

/**
 * Describes the message questionnaire.v2.RiskQuestionnaire.
 * Use `create(RiskQuestionnaireSchema)` to create a new message.
 */
export const RiskQuestionnaireSchema: GenMessage<RiskQuestionnaire> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 14);

/**
 * @generated from message questionnaire.v2.RiskQuestionnaireQuestions
 */
export type RiskQuestionnaireQuestions = Message<"questionnaire.v2.RiskQuestionnaireQuestions"> & {
  /**
   * @generated from field: repeated questionnaire.v2.RiskQuestionnaireQuestion questions = 1;
   */
  questions: RiskQuestionnaireQuestion[];
};

/**
 * Describes the message questionnaire.v2.RiskQuestionnaireQuestions.
 * Use `create(RiskQuestionnaireQuestionsSchema)` to create a new message.
 */
export const RiskQuestionnaireQuestionsSchema: GenMessage<RiskQuestionnaireQuestions> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 15);

/**
 * @generated from message questionnaire.v2.RiskQuestionnaireQuestion
 */
export type RiskQuestionnaireQuestion = Message<"questionnaire.v2.RiskQuestionnaireQuestion"> & {
  /**
   * @generated from field: string control_id = 1;
   */
  controlId: string;

  /**
   * @generated from field: string control_category = 2;
   */
  controlCategory: string;

  /**
   * @generated from field: string control_definition = 3;
   */
  controlDefinition: string;

  /**
   * @generated from field: controls.v1.ControlStatus control_status = 4;
   */
  controlStatus: ControlStatus;

  /**
   * @generated from field: bool manual_status = 5;
   */
  manualStatus: boolean;

  /**
   * @generated from field: int32 order_priority = 6;
   */
  orderPriority: number;

  /**
   * @generated from field: controls.v1.AnalysisResult analysis_result = 7;
   */
  analysisResult?: AnalysisResult;

  /**
   * @generated from field: optional bool is_suggestion_accepted = 8;
   */
  isSuggestionAccepted?: boolean;

  /**
   * @generated from field: repeated inventory.v1.RiskQuestionnaireQuestionThreadActivity activities = 9;
   */
  activities: RiskQuestionnaireQuestionThreadActivity[];

  /**
   * @generated from field: optional bool is_resolved = 10;
   */
  isResolved?: boolean;

  /**
   * True when the vendor-attestation classifier set the status rather than a reviewer.
   * manual_status is true for both, since each writes a status-change row.
   *
   * @generated from field: bool ai_attested = 11;
   */
  aiAttested: boolean;
};

/**
 * Describes the message questionnaire.v2.RiskQuestionnaireQuestion.
 * Use `create(RiskQuestionnaireQuestionSchema)` to create a new message.
 */
export const RiskQuestionnaireQuestionSchema: GenMessage<RiskQuestionnaireQuestion> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 16);

/**
 * @generated from message questionnaire.v2.RiskQuestionnaireArtifact
 */
export type RiskQuestionnaireArtifact = Message<"questionnaire.v2.RiskQuestionnaireArtifact"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string artifact_category = 3;
   */
  artifactCategory: string;

  /**
   * @generated from field: string artifact_subcategory = 4;
   */
  artifactSubcategory: string;

  /**
   * @generated from field: int32 questions_answered = 5;
   */
  questionsAnswered: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: artifacts.v1.DocumentError document_error = 7;
   */
  documentError: DocumentError;
};

/**
 * Describes the message questionnaire.v2.RiskQuestionnaireArtifact.
 * Use `create(RiskQuestionnaireArtifactSchema)` to create a new message.
 */
export const RiskQuestionnaireArtifactSchema: GenMessage<RiskQuestionnaireArtifact> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 17);

/**
 * @generated from message questionnaire.v2.ManualOption
 */
export type ManualOption = Message<"questionnaire.v2.ManualOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string option_label = 2;
   */
  optionLabel: string;

  /**
   * @generated from field: bool is_flag = 3;
   */
  isFlag: boolean;

  /**
   * @generated from field: bool is_select = 4;
   */
  isSelect: boolean;

  /**
   * @generated from field: bool needs_explanation = 5;
   */
  needsExplanation: boolean;
};

/**
 * Describes the message questionnaire.v2.ManualOption.
 * Use `create(ManualOptionSchema)` to create a new message.
 */
export const ManualOptionSchema: GenMessage<ManualOption> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 18);

/**
 * @generated from message questionnaire.v2.ManualBaseQuestion
 */
export type ManualBaseQuestion = Message<"questionnaire.v2.ManualBaseQuestion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: questionnaire.v2.ManualQuestionKind kind = 2;
   */
  kind: ManualQuestionKind;

  /**
   * @generated from field: string question = 3;
   */
  question: string;

  /**
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * @generated from field: string sub_category = 5;
   */
  subCategory: string;

  /**
   * @generated from field: bool is_leading = 6;
   */
  isLeading: boolean;

  /**
   * @generated from field: optional string note = 7;
   */
  note?: string;

  /**
   * @generated from field: questionnaire.v2.ManualQuestionStatus status = 8;
   */
  status: ManualQuestionStatus;

  /**
   * @generated from field: int32 display_order = 9;
   */
  displayOrder: number;
};

/**
 * Describes the message questionnaire.v2.ManualBaseQuestion.
 * Use `create(ManualBaseQuestionSchema)` to create a new message.
 */
export const ManualBaseQuestionSchema: GenMessage<ManualBaseQuestion> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 19);

/**
 * @generated from message questionnaire.v2.ManualRadioDetails
 */
export type ManualRadioDetails = Message<"questionnaire.v2.ManualRadioDetails"> & {
  /**
   * @generated from field: repeated questionnaire.v2.ManualOption options = 1;
   */
  options: ManualOption[];

  /**
   * @generated from field: optional string explanation = 2;
   */
  explanation?: string;
};

/**
 * Describes the message questionnaire.v2.ManualRadioDetails.
 * Use `create(ManualRadioDetailsSchema)` to create a new message.
 */
export const ManualRadioDetailsSchema: GenMessage<ManualRadioDetails> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 20);

/**
 * @generated from message questionnaire.v2.ManualCheckboxDetails
 */
export type ManualCheckboxDetails = Message<"questionnaire.v2.ManualCheckboxDetails"> & {
  /**
   * @generated from field: repeated questionnaire.v2.ManualOption options = 1;
   */
  options: ManualOption[];

  /**
   * @generated from field: optional string explanation = 2;
   */
  explanation?: string;
};

/**
 * Describes the message questionnaire.v2.ManualCheckboxDetails.
 * Use `create(ManualCheckboxDetailsSchema)` to create a new message.
 */
export const ManualCheckboxDetailsSchema: GenMessage<ManualCheckboxDetails> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 21);

/**
 * @generated from message questionnaire.v2.ManualDateDetails
 */
export type ManualDateDetails = Message<"questionnaire.v2.ManualDateDetails"> & {
  /**
   * @generated from field: optional google.protobuf.Timestamp date_answer = 1;
   */
  dateAnswer?: Timestamp;
};

/**
 * Describes the message questionnaire.v2.ManualDateDetails.
 * Use `create(ManualDateDetailsSchema)` to create a new message.
 */
export const ManualDateDetailsSchema: GenMessage<ManualDateDetails> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 22);

/**
 * @generated from message questionnaire.v2.ManualFreeTextDetails
 */
export type ManualFreeTextDetails = Message<"questionnaire.v2.ManualFreeTextDetails"> & {
  /**
   * @generated from field: optional string answer = 1;
   */
  answer?: string;
};

/**
 * Describes the message questionnaire.v2.ManualFreeTextDetails.
 * Use `create(ManualFreeTextDetailsSchema)` to create a new message.
 */
export const ManualFreeTextDetailsSchema: GenMessage<ManualFreeTextDetails> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 23);

/**
 * @generated from message questionnaire.v2.ManualFileDetails
 */
export type ManualFileDetails = Message<"questionnaire.v2.ManualFileDetails"> & {
  /**
   * @generated from field: optional string artifact_id = 1;
   */
  artifactId?: string;

  /**
   * @generated from field: optional string artifact_name = 2;
   */
  artifactName?: string;

  /**
   * @generated from field: optional bool file_cannot_be_provided = 3;
   */
  fileCannotBeProvided?: boolean;
};

/**
 * Describes the message questionnaire.v2.ManualFileDetails.
 * Use `create(ManualFileDetailsSchema)` to create a new message.
 */
export const ManualFileDetailsSchema: GenMessage<ManualFileDetails> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 24);

/**
 * @generated from message questionnaire.v2.ManualQuestionAnswer
 */
export type ManualQuestionAnswer = Message<"questionnaire.v2.ManualQuestionAnswer"> & {
  /**
   * @generated from oneof questionnaire.v2.ManualQuestionAnswer.answer
   */
  answer: {
    /**
     * @generated from field: questionnaire.v2.ManualRadioDetails radio = 1;
     */
    value: ManualRadioDetails;
    case: "radio";
  } | {
    /**
     * @generated from field: questionnaire.v2.ManualCheckboxDetails checkbox = 2;
     */
    value: ManualCheckboxDetails;
    case: "checkbox";
  } | {
    /**
     * @generated from field: questionnaire.v2.ManualFreeTextDetails free_text = 3;
     */
    value: ManualFreeTextDetails;
    case: "freeText";
  } | {
    /**
     * @generated from field: questionnaire.v2.ManualFileDetails file = 4;
     */
    value: ManualFileDetails;
    case: "file";
  } | {
    /**
     * @generated from field: questionnaire.v2.ManualDateDetails date = 6;
     */
    value: ManualDateDetails;
    case: "date";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message questionnaire.v2.ManualQuestionAnswer.
 * Use `create(ManualQuestionAnswerSchema)` to create a new message.
 */
export const ManualQuestionAnswerSchema: GenMessage<ManualQuestionAnswer> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 25);

/**
 * @generated from message questionnaire.v2.ManualQuestion
 */
export type ManualQuestion = Message<"questionnaire.v2.ManualQuestion"> & {
  /**
   * @generated from field: questionnaire.v2.ManualBaseQuestion base = 1;
   */
  base?: ManualBaseQuestion;

  /**
   * @generated from field: questionnaire.v2.ManualQuestionAnswer answer = 2;
   */
  answer?: ManualQuestionAnswer;

  /**
   * @generated from field: repeated questionnaire.v2.ManualQuestionThreadActivity activities = 3;
   */
  activities: ManualQuestionThreadActivity[];
};

/**
 * Describes the message questionnaire.v2.ManualQuestion.
 * Use `create(ManualQuestionSchema)` to create a new message.
 */
export const ManualQuestionSchema: GenMessage<ManualQuestion> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 26);

/**
 * What Lema observed about the vendor, shown at the top of a campaign questionnaire started from a preset.
 *
 * @generated from message questionnaire.v2.OutreachCampaignFinding
 */
export type OutreachCampaignFinding = Message<"questionnaire.v2.OutreachCampaignFinding"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp observed_at = 4;
   */
  observedAt?: Timestamp;

  /**
   * @generated from field: repeated questionnaire.v2.OutreachCampaignFindingEvidence evidence = 5;
   */
  evidence: OutreachCampaignFindingEvidence[];

  /**
   * @generated from field: string subtitle = 6;
   */
  subtitle: string;
};

/**
 * Describes the message questionnaire.v2.OutreachCampaignFinding.
 * Use `create(OutreachCampaignFindingSchema)` to create a new message.
 */
export const OutreachCampaignFindingSchema: GenMessage<OutreachCampaignFinding> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 27);

/**
 * @generated from message questionnaire.v2.OutreachCampaignFindingEvidence
 */
export type OutreachCampaignFindingEvidence = Message<"questionnaire.v2.OutreachCampaignFindingEvidence"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string quote = 2;
   */
  quote: string;

  /**
   * @generated from field: string context = 3;
   */
  context: string;
};

/**
 * Describes the message questionnaire.v2.OutreachCampaignFindingEvidence.
 * Use `create(OutreachCampaignFindingEvidenceSchema)` to create a new message.
 */
export const OutreachCampaignFindingEvidenceSchema: GenMessage<OutreachCampaignFindingEvidence> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_model, 28);

/**
 * @generated from enum questionnaire.v2.QuestionnaireType
 */
export enum QuestionnaireType {
  /**
   * @generated from enum value: QUESTIONNAIRE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUESTIONNAIRE_TYPE_INFO = 1;
   */
  INFO = 1,

  /**
   * @generated from enum value: QUESTIONNAIRE_TYPE_RISK = 2;
   */
  RISK = 2,
}

/**
 * Describes the enum questionnaire.v2.QuestionnaireType.
 */
export const QuestionnaireTypeSchema: GenEnum<QuestionnaireType> = /*@__PURE__*/
  enumDesc(file_questionnaire_v2_model, 0);

/**
 * @generated from enum questionnaire.v2.ManualQuestionKind
 */
export enum ManualQuestionKind {
  /**
   * @generated from enum value: MANUAL_QUESTION_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MANUAL_QUESTION_KIND_RADIO = 1;
   */
  RADIO = 1,

  /**
   * @generated from enum value: MANUAL_QUESTION_KIND_CHECKBOX = 2;
   */
  CHECKBOX = 2,

  /**
   * @generated from enum value: MANUAL_QUESTION_KIND_FREE_TEXT = 3;
   */
  FREE_TEXT = 3,

  /**
   * @generated from enum value: MANUAL_QUESTION_KIND_FILE = 4;
   */
  FILE = 4,

  /**
   * @generated from enum value: MANUAL_QUESTION_KIND_DATE = 5;
   */
  DATE = 5,
}

/**
 * Describes the enum questionnaire.v2.ManualQuestionKind.
 */
export const ManualQuestionKindSchema: GenEnum<ManualQuestionKind> = /*@__PURE__*/
  enumDesc(file_questionnaire_v2_model, 1);

/**
 * @generated from enum questionnaire.v2.ManualQuestionStatus
 */
export enum ManualQuestionStatus {
  /**
   * @generated from enum value: MANUAL_QUESTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MANUAL_QUESTION_STATUS_UNANSWERED = 1;
   */
  UNANSWERED = 1,

  /**
   * @generated from enum value: MANUAL_QUESTION_STATUS_NEEDS_REVIEW = 2;
   */
  NEEDS_REVIEW = 2,

  /**
   * @generated from enum value: MANUAL_QUESTION_STATUS_ACCEPTED = 3;
   */
  ACCEPTED = 3,

  /**
   * @generated from enum value: MANUAL_QUESTION_STATUS_REJECTED = 4;
   */
  REJECTED = 4,
}

/**
 * Describes the enum questionnaire.v2.ManualQuestionStatus.
 */
export const ManualQuestionStatusSchema: GenEnum<ManualQuestionStatus> = /*@__PURE__*/
  enumDesc(file_questionnaire_v2_model, 2);

